import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../commonDesign/SydModal'
import ImageList from '../../media/ImageList'
import Loading from '../../../../molecules/Loading'
import AddImageForm from './images/addForm'

export const BrandImageModals = ({
  viewImageListModal, onCloseImageList,
  images, imagesLoading, selectedImage, onSelectImage,
  openAddImageModal, onCompleteAddImage, onCloseAddImage
}) => (
  <>
    <SydModal
      open={viewImageListModal}
      onClose={onCloseImageList}
      title='Select Image'
    >
      {imagesLoading ? (
        <Loading />
      ) : !images?.data?.length ? (
        <p>No data</p>
      ) : (
        <ImageList
          images={images.data}
          onSelect={onSelectImage}
          selectedImage={selectedImage}
        />
      )}
    </SydModal>
    {openAddImageModal && (
      <AddImageForm
        open={openAddImageModal}
        onComplete={onCompleteAddImage}
        onClose={onCloseAddImage}
      />
    )}
  </>
)

BrandImageModals.propTypes = {
  viewImageListModal: PropTypes.bool,
  onCloseImageList: PropTypes.func,
  images: PropTypes.object,
  imagesLoading: PropTypes.bool,
  selectedImage: PropTypes.object,
  onSelectImage: PropTypes.func,
  openAddImageModal: PropTypes.bool,
  onCompleteAddImage: PropTypes.func,
  onCloseAddImage: PropTypes.func
}

export default BrandImageModals
